module.exports = __webpack_public_path__ + "static/media/return_button.3f950c34.svg";